import { Component, Input } from '@angular/core';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { FiltreService } from '../../../filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';
import { IntegerMaskInputComponent } from '../../integer-mask-input/integer-mask-input.component';

@Component({
  selector: 'bis-integer-mask-input-keypad',
  templateUrl: './integer-mask-input-keypad.component.html',
  styleUrls: ['../../input/input.component.css']
})
export class IntegerMaskInputKeypadComponent extends IntegerMaskInputComponent {
  @Input()
  classeSupplInput: string = 'text-right';
  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
     super(formulaireService, libelleService, filtreService, modeRenduService);
   }

  public scroll(element: any) {
    element.scrollIntoView({block: 'center', behavior: 'auto'});
  }
}